<div class="hexagon">
  <div class="hexagon__game">
    <app-hexagon-glow-svg
      class="hexagon__glow"
      [class.hexagon__glow--pulse]="spinService.isSpinning()"
      [color]="getStateColor()"
    />
    <img class="hexagon__bg-outer" src='assets/images/img.png'>
    <img class="hexagon__bg-inner" src='assets/images/img_1.png'>
    <svg-icon
      class="hexagon__frame"
      src="assets/icons/updater/hexagon-frame.svg"
    />
    <svg-icon
      class="hexagon__ticks"
      src="assets/icons/updater/hexagon-ticks.svg"
    />
    <app-hexagon-border-outer-svg
      class="hexagon__border-outer"
      [class.hexagon__border-outer--pulse]="spinService.isSpinning()"
      [color]="getStateColor()"
    />
    <app-hexagon-edges-svg
      class="hexagon__edges"
      [class.hexagon__edges--pulse]="spinService.isSpinning()"
      [color]="getStateColor()"
      [colorWithOpacity]="getStateColorWithOpacity(0.5)"
    />
    <app-hexagon-border-svg
      class="hexagon__border"
      [color]="getStateColor()"
      [dashArray]="getBorderDashArray()"
      [dashOffset]="getBorderDashOffset()"
      (pathLengthCalculated)="onPathLengthCalculated($event)"
    />
    <div class="hexagon__inner">
      <canvas #smokeCanvas class="hexagon__smoke"></canvas>
      <div #trailEl class="hexagon__trail"
        [class.hexagon__trail--visible]="spinService.isSpinning()"
      ></div>
      @if (state() !== 'won' && state() !== 'lost') {
        <div #arrowEl class="hexagon__arrow">
          <app-hexagon-arrow-svg />
        </div>
      }
      <div class="hexagon__info">
        @if (state() === 'won' && wonItemImage()) {
            <div class="hexagon__info-won">
                <img [src]="wonItemImage()" alt="Won item"/>
                <div class="hexagon__info-amount hexagon__info-amount--won">
                    <svg-icon
                            class="flex items-center justify-center"
                            src="assets/icons/core/skins.svg"
                    ></svg-icon>
                    {{ wonAmount() | number:'1.2-2' }}
                </div>
            </div>
        } @else if (state() === 'lost') {
            <div class="hexagon__info-failed"><span>UPGRADE</span> FAILED</div>
            <!--<div class="hexagon__info-amount hexagon__info-amount&#45;&#45;lost">
                <svg-icon
                        class="flex items-center justify-center"
                        src="assets/icons/core/skins.svg"
                ></svg-icon>
                -{{ lostAmount() | number:'1.2-2' }}
            </div>-->
            <div class="hexagon__info-roll">Roll {{ roll() | number:'1.2-2' }}</div>
        } @else {
          <div class="hexagon__info-hint">Сhance</div>
          <div class="hexagon__info-value">
            {{ chance() | number:'1.2-2' }} <span>%</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
